import { request } from './repository';

const url = 'collaborator-functions/';

const collaboratorFunctionRepository = {
    getCollaboratorFunctions(params){
        return request.get(url, params);
    },
    storeCollaboratorFunction(data){
        return request.post(url, data);
    },
    deleteCollaboratorFunction(id) {
        return request.delete(url + id);
    },
    updateCollaboratorFunction(id, data) {
        return request.put(url + id, data);
    }
}

export default collaboratorFunctionRepository